export default "__VITE_ASSET__BjdJMyoX__"